import { makeStyles } from '@material-ui/core/styles';
import { colorMap, BackgroundColors, SecondaryColors, TextColors } from '@/utils/constants';

const darkTheme = {
  root: {
    backgroundColor: BackgroundColors.dark,

    '& $navArrow': {
      '&.MuiButtonBase-root': {
        '&.slick-next, &.slick-prev': {
          '&:not(:hover)': {
            color: TextColors.light,
          },

          '&:hover': {
            color: SecondaryColors.main,
          },
        },
      },
    },

    '& $title': {
      color: SecondaryColors.main,
    },

    '& $focusImage': {
      backgroundColor: BackgroundColors.dark,
    },

    '& $pagination': {
      color: TextColors.light,
    },

    '&.is-inline': {
      '& $navArrow': {
        '&.MuiButtonBase-root': {
          '&.slick-next, &.slick-prev': {
            '&:not(:hover)': {
              color: SecondaryColors.main,
            },

            '&:hover': {
              color: SecondaryColors.light,
            },
          },
        },
      },

      '& $title': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    backgroundColor: BackgroundColors.light,

    '& $navArrow': {
      '&.MuiButtonBase-root': {
        '&.slick-next, &.slick-prev': {
          '&:not(:hover)': {
            color: TextColors.dark,
          },

          '&:hover': {
            color: SecondaryColors.dark,
          },
        },
      },
    },

    '& $title': {
      color: SecondaryColors.dark,
    },

    '& $focusImage': {
      backgroundColor: BackgroundColors.light,
    },

    '& $pagination': {
      color: TextColors.dark,
    },

    '&.is-inline': {
      '& $navArrow': {
        '&.MuiButtonBase-root': {
          '&.slick-next, &.slick-prev': {
            '&:not(:hover)': {
              color: SecondaryColors.dark,
            },

            '&:hover': {
              color: SecondaryColors.main,
            },
          },
        },
      },

      '& $title': {
        color: TextColors.dark,
      },
    },
  },
};

const getInline = (muiTheme: any) => ({
  root: {
    '& $focusImage': {
      '& figure': {
        height: 'auto',
        borderRadius: '4px',
      },
    },

    '& $caption': {
      '&.is-inline': {
        padding: muiTheme.spacing(2, 6.5, 2, 0),
      },
    },

    '& $title': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },

    '& $nextArrow': {
      '&.MuiButtonBase-root': {
        '&.slick-next': {
          right: '-8px',

          [muiTheme.breakpoints.up('lg')]: {
            marginRight: '0',
          },
        },
      },
    },

    '& $prevArrow': {
      '&.MuiButtonBase-root': {
        '&.slick-prev': {
          left: 'auto',
          right: '24px',

          [muiTheme.breakpoints.up('lg')]: {
            marginLeft: '0',
          },
        },
      },
    },

    '& $navArrow': {
      '&.MuiButtonBase-root': {
        '&.slick-next, &.slick-prev': {
          top: 'auto',
          bottom: '-2px',
          zIndex: 100,
        },
      },
    },
  },
});

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&.is-inline': getInline(muiTheme).root,
      borderRadius: '4px',

      '& .slick-list': {
        borderRadius: '4px',
      },

      '& .slick-prev:before, .slick-next:before': {
        content: '"" !important',
      },
    },
    nextArrow: {
      '&.MuiButtonBase-root': {
        '&.slick-next': {
          right: '-32px',

          [muiTheme.breakpoints.up('lg')]: {
            marginRight: '-64px',
            right: '0',
          },

          '&.is-inline': {
            right: '-8px',
          },
        },
      },
    },
    prevArrow: {
      '&.MuiButtonBase-root': {
        '&.slick-prev': {
          left: '-32px',

          [muiTheme.breakpoints.up('lg')]: {
            left: '0',
            marginLeft: '-64px',
          },
        },
      },
    },
    navArrow: {
      '&.MuiButtonBase-root': {
        display: 'flex',
        zIndex: 1,

        '&.slick-next, &.slick-prev': {
          height: 'auto',
          width: 'auto',
        },

        '& .MuiSvgIcon-fontSizeLarge': {
          fontSize: '64px',
        },
      },
    },

    focusImage: {
      '& figure': {
        backgroundColor: colorMap.black,
        margin: '0',
        justifyContent: 'center',
        display: 'flex',
        overflow: 'hidden',
        height: '250px',
        borderRadius: '0',

        '& picture': {
          width: '100%',
        },

        [muiTheme.breakpoints.up('sm')]: {
          height: '350px',
        },

        [muiTheme.breakpoints.up('md')]: {
          height: '550px',
        },
      },
    },

    caption: {
      padding: muiTheme.spacing(1.5, 6.5, 1.5, 1.5),
      minHeight: '44px',
    },

    pagination: {},

    title: {},
  }),
  { name: 'GenImageCarousel' },
);

export default useStyles;
